<template>
  <CRow>
    <CCol>
      <!--UPLOAD-->
      <form
        enctype="multipart/form-data"
        novalidate
        v-if="isInitial || isSaving"
      >
        <!-- <h4>Upload images</h4> -->
        <div class="dropbox">
          <input
            type="file"
            multiple
            :name="uploadFieldName"
            :disabled="isSaving"
            @change="
              filesChange($event.target.name, $event.target.files);
              fileCount = $event.target.files.length;
            "
            :accept="acceptAttribute"
            class="input-file"
          />
          <p v-if="isInitial">
            Drag your file(s) here to begin<br />
            or click to browse
          </p>
          <p v-if="isSaving">Uploading {{ fileCount }} files. Please wait...</p>
        </div>
      </form>
      <!--SUCCESS-->
      <div v-if="isSuccess">
        <p>{{ uploadedFiles.length }} row(s) added.</p>
        <p>
          <a href="javascript:void(0)" @click="reset()"
            >Click to upload again</a
          >
        </p>
        <!-- <ul class="list-unstyled">
          <li v-for="item in uploadedFiles">
            <CLink :href="getCollectionScheduleUrl(item)">{{
              getCollectionScheduleName(item)
            }}</CLink>
       
          </li>
        </ul> -->
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <p>Added failed.</p>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </CCol>
  </CRow>
</template>

<script>
// swap as you need
//import { upload } from './file-upload.fake.service'; // fake service
import FileUploadApi from "../../lib/fileUploadApi"; // real service
import { wait } from "../../lib/utils";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

// Mirror nginx `client_max_body_size` + Kestrel MultipartBodyLengthLimit.
// See WidgetsUploadImage.vue for the same constant.
const MAX_UPLOAD_BYTES = 100 * 1024 * 1024; // 100 MB

export default {
  name: "WidgetsUploadDocument",
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ['application/pdf']
    },
    maxFileSize: {
      type: Number,
      default: 5
    },
    label: {
      type: String,
      default: 'Upload Document'
    }
  },
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "image",
      fileUploadApi: new FileUploadApi(),
    };
  },
  computed: {
    acceptAttribute() {
      // Convert MIME types to file extensions for the accept attribute
      const mimeToExt = {
        'application/pdf': '.pdf',
        'image/jpeg': '.jpg,.jpeg',
        'image/png': '.png',
        'image/jpg': '.jpg',
        'image/gif': '.gif',
        'image/bmp': '.bmp',
        'image/webp': '.webp'
      };

      return this.acceptedFileTypes
        .map(mime => mimeToExt[mime] || '')
        .filter(ext => ext)
        .join(',');
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    getCollectionScheduleName(item) {
      return item.fileName;
    },
    getCollectionScheduleUrl(item) {
      return item.url;
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.fileUploadApi
        .uploadDocument(formData)
        .then((x) => {
          this.uploadedFiles = [].concat(x.result);
          this.currentStatus = STATUS_SUCCESS;
          this.$emit("uploaded", {
            uploadedFiles: this.uploadedFiles,
          });
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChange(fieldName, fileList) {
      const formData = new FormData();

      if (!fileList.length) return;

      // Reject oversize files before sending — nginx's 413 lacks CORS
      // headers and would surface as a confusing "CORS error" instead
      // of "file too big." Same limit as WidgetsUploadImage.
      const files = Array.from(fileList);
      const oversized = files.filter((f) => f.size > MAX_UPLOAD_BYTES);
      if (oversized.length > 0) {
        const names = oversized.map((f) => `${f.name} (${Math.round(f.size / 1024 / 1024)} MB)`).join(", ");
        this.uploadError = `File too large (max ${MAX_UPLOAD_BYTES / 1024 / 1024} MB): ${names}`;
        this.currentStatus = STATUS_FAILED;
        return;
      }

      files.forEach((file) => {
        formData.append(fieldName, file, file.name);
      });
      this.save(formData);
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>